module.exports = __webpack_public_path__ + "img/Day5_final.3756298e.jpg";